import React from "react";
import MapPin from "../../../../icons/MapPin";
import { Button } from "../../../../shadcn/components/ui/button";
// import Dot from "../../../../icons/Dot";
import DownloadIcon from "../../../../icons/DownloadIcon";
import { useRouter } from "next/router";
import { getFileByUuid } from "services";

type EventKeyValueType = {
  key: string;
  value: any;
};

interface PropertyAuctionCardProps {
  userType: any;
  fileUuid: any;
  bidderUuid: any;
  rejectionReason: any;
  headingText?: string;
  subHeadingText?: string;
  imgLink: string;
  tagText: string | null;
  secondaryTagText: string | null;
  AuctionEventKeyValueData: Array<EventKeyValueType>;
  ctaProps: {
    ctaText: string;
    ctaHandler: () => void;
    disabled?: boolean;
    ctaStyle?: string;
  };
  biddingDetails: {
    startDate: string;
    endDate: string;
    style?: {
      cardBackgroundImage: string;
      cardLeftBorderColor: string;
    };
  };
  kycStatus: any;
  activeTabKey: any;
  style?: {
    imgStyle?: string;
    tagStyle?: string;
  };
  listingId: any;
}

const PropertyAuctionCard: React.FC<PropertyAuctionCardProps> = ({
  userType = "banker",
  bidderUuid,
  rejectionReason = "Banker Rejected your Application",
  fileUuid = null,
  headingText = "Heading Text",
  subHeadingText = "Subheading Text",
  kycStatus,
  imgLink,
  tagText,
  secondaryTagText,
  AuctionEventKeyValueData = [],
  ctaProps,
  listingId = "listing",
  biddingDetails = {
    startDate: "08 August 2024, 01:25 PM (IST)",
    endDate: "08 August 2024, 05:00 PM (IST)",
    style: {
      cardBackgroundImage: "bg-linear-purple",
      cardLeftBorderColor: "border-[#5D5FEF]",
    },
  },
  activeTabKey,
  style,
}) => {
  const router = useRouter();
  const getAlignmentClass = (index: number, length: number) => {
    if (index === 0) return "justify-left";
    if (index + 1 === length) return "justify-end";
    return "justify-center";
  };
  return (
    <div className="relative bg-white hover:shadow-lg">
      <div>
        {tagText && (
          <div
            className={`absolute left-0 top-0 pl-4 py-1 pr-9 uppercase font-sans text-xs md:text-sm ${
              style?.tagStyle || "bg-[#FFF3F3] text-[#B60100]"
            }`}
            style={{
              clipPath: "polygon(0% 0%, 85% 0%, 100% 100%, 100% 100%, 0% 100%)",
            }}
          >
            {tagText}
          </div>
        )}
        {secondaryTagText && activeTabKey === "bid_application" && (
          <div
            className={`absolute right-0 lg:right-auto top-0 lg:top-2 lg:left-1/2 lg:-translate-x-1/2 px-3 py-0 capitalize font-sans text-sm tracking-wider rounded-sm lg:rounded-full ${
              secondaryTagText === "Live"
                ? "bg-brand-bgSuccessGreen text-white"
                : "bg-[#FFF3F3] text-[#B60100]"
            }`}
          >
            {secondaryTagText}
          </div>
        )}
        <div className="hidden lg:inline-block absolute right-2 top-2">
          <div className="px-3 rounded-full flex items-center -py-2">
            <span className="text-brand-orange text-xs sm:text-base pl-2 uppercase break-keep font-semibold">
              ID: {listingId}
            </span>
          </div>
        </div>
        {(activeTabKey === "upcoming_events" ||
          activeTabKey === "bid_application") && (
          <div className="absolute left-0 top-0">
            <div
              className={`pl-4 py-1 pr-9 uppercase font-sans text-xs md:text-sm tracking-wider ${
                kycStatus === "Incomplete Application"
                  ? "bg-[#FFF3F3] text-[#ff752c]"
                  : kycStatus === "Awaiting Banker Approval"
                  ? "bg-[#FFF3F3] text-[#ff752c]"
                  : kycStatus === "Banker Rejected"
                  ? "bg-[#F3080C] text-white"
                  : "bg-brand-bgSuccessGreen text-brand-textWhite"
              }`}
              style={{
                clipPath:
                  "polygon(0% 0%, 85% 0%, 100% 100%, 100% 100%, 0% 100%)",
              }}
            >
              {kycStatus}
            </div>
            {(activeTabKey === "upcoming_events" ||
              activeTabKey === "bid_application") &&
              kycStatus === "Banker Rejected" &&
              secondaryTagText !== "Ended" && (
                <div className="pl-4 pb-4 text-xs">
                  <span className="font-bold">Reason:</span>{" "}
                  <span>
                    {rejectionReason?.length < 24
                      ? rejectionReason
                      : `${rejectionReason?.slice(0, 24)}`}
                    .....
                  </span>
                  <span
                    onClick={() => {
                      router.replace(`/kyc/${bidderUuid}`);
                    }}
                    className="text-[#1C64F2] cursor-pointer"
                  >
                    See More
                  </span>
                </div>
              )}
          </div>
        )}
      </div>
      <div className="w-full pt-12 pb-6 hidden lg:flex justify-between px-5 text-[10px]">
        <div className="flex flex-col gap-5">
          <div>
            <div className="relative">
              {headingText && (
                <h3 className="text-brand-textBlack font-sans text-lg xl:text-xl font-semibold capitalize">
                  {headingText}
                </h3>
              )}
              {subHeadingText && (
                <div className="flex items-start">
                  <MapPin className="mr-1" />
                  <span className="text-[11px] xl:text-sm text-brand-textGrey capitalize">
                    {subHeadingText}
                  </span>
                </div>
              )}
              {userType === "user" &&
                kycStatus !== "Incomplete Application" &&
                fileUuid && (
                  <div
                    className="absolute top-2 right-0 cursor-pointer hover:text-brand-orange"
                    onClick={async () => {
                      const d: any = await getFileByUuid(fileUuid);
                      router.push(d?.download_url);
                    }}
                  >
                    <div className="px-3 rounded-full flex items-center py-1 justify-self-end">
                      {<DownloadIcon />}
                      <span className="text-sm pl-2 font-normal break-keep underline text-[#1C64F2]">
                        Download Bid Form
                      </span>
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div className="flex bg-[#A8A8A8] gap-x-[1px] items-center text-[10px] mt-2">
            {AuctionEventKeyValueData.map((item, index) => (
              <div
                key={`EventKeyValueType_${index}`}
                className={`flex items-center w-full bg-white text-left ${getAlignmentClass(
                  index,
                  AuctionEventKeyValueData.length,
                )}`}
              >
                <div className="xl:max-w-[168px] px-2">
                  <div>{item.key}</div>
                  <div className="text-xs leading-5 capitalize truncate">
                    {item.value}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap-6 items-end">
            {/* Bidding Info */}
            {biddingDetails && (
              <>
                <div
                  className={`${biddingDetails?.style?.cardBackgroundImage} border-l-[2px] ${biddingDetails?.style?.cardLeftBorderColor} py-3 pl-6 flex flex-col mid:flex-row gap-4 mid:gap-11`}
                >
                  <div className="min-w-[190px]">
                    <div>Bidding Start Date and Time</div>
                    <div className="text-xs break-keep">
                      {biddingDetails.startDate}
                    </div>
                  </div>
                  <div className="min-w-[190px]">
                    <div>Bidding End Date and Time</div>
                    <div className="text-xs break-keep">
                      {biddingDetails.endDate}
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="w-[195px]">
              {activeTabKey !== "upcoming_events" &&
              activeTabKey !== "bid_application" ? (
                <Button
                  className={`w-full bg-white text-brand-textBlack border border-brand-borderGrey hover:bg-white hover:text-brand-textBlack hover:shadow-md px-14 ${
                    ctaProps.ctaStyle || ""
                  }`}
                  onClick={() => {
                    ctaProps?.ctaHandler();
                  }}
                  disabled={ctaProps.disabled}
                >
                  {ctaProps.ctaText}
                </Button>
              ) : (
                <Button
                  className={`w-full bg-white text-brand-textBlack border border-brand-borderGrey hover:bg-white hover:text-brand-textBlack hover:shadow-md px-14 ${
                    ctaProps.ctaStyle || ""
                  }`}
                  onClick={() => {
                    router.replace(`/kyc/${bidderUuid}`);
                  }}
                  disabled={
                    secondaryTagText === "Ended" ||
                    kycStatus === "Verified Application" ||
                    kycStatus === "Awaiting Baker Approval"
                  }
                >
                  {kycStatus === "Verified Application" ||
                  kycStatus === "Awaiting Baker Approval"
                    ? ctaProps.ctaText
                    : kycStatus === "Incomplete Application"
                    ? "Complete Now!"
                    : "Check Now!"}
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className={`self-end justify-self-end ${style?.imgStyle}`}>
          {imgLink && (
            <img
              src={imgLink}
              className={`${style?.imgStyle || ""}`}
              alt="Property Auction"
            />
          )}
        </div>
      </div>
      <div className="lg:hidden py-12 px-4">
        <div className="flex justify-between">
          <div className="text-xs font-sans">
            <div className="text-brand-textBlack">Auction Event</div>
            <div className="text-brand-orange">ID: {listingId}</div>
          </div>
          {userType === "user" &&
            kycStatus !== "Incomplete Application" &&
            fileUuid && (
              <div
                className="cursor-pointer hover:text-brand-orange"
                onClick={async () => {
                  const d: any = await getFileByUuid(fileUuid);
                  router.push(d?.download_url);
                }}
              >
                <div className="px-3 rounded-full flex items-center py-1 justify-self-end">
                  {<DownloadIcon />}
                  <span className="text-xs sm:text-sm pl-2 font-normal break-keep underline text-[#1C64F2]">
                    Download Bid Form
                  </span>
                </div>
              </div>
            )}
        </div>
        <div className="grid grid-cols-2 gap-y-4 items-center text-[10px] mt-6">
          {AuctionEventKeyValueData.map((item, index) => (
            <div
              key={`EventKeyValueType_${index}`}
              className={`flex items-center ${
                index % 2 === 0
                  ? "w-full "
                  : "justify-center border-l-[1px] border-[#A8A8A8]"
              }`}
            >
              <div className="">
                <div>{item.key}</div>
                <div className="text-xs leading-5">{item.value}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={`mt-4 ${style?.imgStyle}`}>
          {imgLink && (
            <img
              src={imgLink}
              className={`${style?.imgStyle || ""}`}
              alt="Property Auction"
            />
          )}
        </div>
        <div className="flex flex-col gap-y-4 mt-4">
          <div
            className={`w-full ${biddingDetails?.style?.cardBackgroundImage} border-l-[2px] ${biddingDetails?.style?.cardLeftBorderColor} text-xs py-[10px] px-4`}
          >
            <div className="leading-6">Bidding Start Date and Time</div>
            <div className="text-xs break-keep">{biddingDetails.startDate}</div>
          </div>
          <div
            className={`w-full ${biddingDetails?.style?.cardBackgroundImage} border-l-[2px] ${biddingDetails?.style?.cardLeftBorderColor} text-xs py-[10px] px-4`}
          >
            <div className="leading-6">Bidding End Date and Time</div>
            <div className="text-xs break-keep">{biddingDetails.endDate}</div>
          </div>
        </div>
        <div className="mt-8">
          {activeTabKey !== "upcoming_events" &&
          activeTabKey !== "bid_application" ? (
            <Button
              className={`w-full bg-white text-brand-textBlack border border-brand-borderGrey hover:bg-white hover:text-brand-textBlack hover:shadow-md px-14 ${
                ctaProps.ctaStyle || ""
              }`}
              onClick={() => {
                ctaProps?.ctaHandler();
              }}
              disabled={ctaProps.disabled}
            >
              {ctaProps.ctaText}
            </Button>
          ) : (
            <Button
              className={`w-full bg-white text-brand-textBlack border border-brand-borderGrey hover:bg-white hover:text-brand-textBlack hover:shadow-md px-14 ${
                ctaProps.ctaStyle || ""
              }`}
              onClick={() => {
                router.replace(`/kyc/${bidderUuid}`);
              }}
              disabled={
                secondaryTagText === "Ended" ||
                kycStatus === "Verified Application" ||
                kycStatus === "Awaiting Baker Approval"
              }
            >
              {kycStatus === "Verified Application" ||
              kycStatus === "Awaiting Baker Approval"
                ? ctaProps.ctaText
                : kycStatus === "Incomplete Application"
                ? "Complete Now!"
                : "Check Now!"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyAuctionCard;
